import { Button, Group } from '@mantine/core';
import { useFormContext } from 'react-hook-form';

type FormActionsPropsType = {
  onCancel: () => void;
  saveButtonText: string;
  cancelButtonText: string;
};

export const FormActions: React.FC<FormActionsPropsType> = ({
  onCancel,
  saveButtonText,
  cancelButtonText,
}) => {
  const form = useFormContext();

  const loading = form.formState.isSubmitting;
  const disabled = !form.formState.isDirty || loading;

  return (
    <Group justify="end">
      <Button variant="outline" onClick={onCancel} color="blue">
        {cancelButtonText}
      </Button>
      <Button type="submit" color="blue" loading={loading} disabled={disabled}>
        {saveButtonText}
      </Button>
    </Group>
  );
};
